import { BaseResource } from "utils/ApiUtils";

class Material extends BaseResource {
  constructor(args) {
    super(args, Material.attributes);
  }

  static columns = [
    {
      title: "Project Id",
      field: "ProjectId_WorkItem",
      type: "string",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Material Id",
      field: "materialId",
      type: "string",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Ihwi Id",
      field: "ihwiId",
      type: "string",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Material Name Id",
      field: "materialNameId",
      type: "string",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Material Type Id",
      field: "materialTypeId",
      type: "string",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Quantity",
      field: "quantity",
      type: "numeric",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Units",
      field: "units",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Inspection #",
      field: "InspectionNumber_Inspection",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    { type: "string", title: "Inspector", field: "Name_SystemUser" },
    {
      title: "Delivered By",
      field: "deliveredBy",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Delivered To",
      field: "deliveredTo",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Ticket Number",
      field: "ticketNumber",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Description",
      field: "description",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Stockpiled",
      field: "stockpiled",
      type: "boolean",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Approved Materials Yn",
      field: "approvedMaterialsYn",
      type: "boolean",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Date Observed",
      field: "dateObserved",
      type: "date",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      type: "string",
      field: "description_MaterialName",
      title: "Material Name",
    },
    {
      type: "string",
      field: "description_MaterialType",
      title: "Material Type",
    },
  ];

  static attributes = Material.columns.map((r) => r.field);

  static expand = [
    { MaterialName: { select: ["description"] } },
    { MaterialType: { select: ["description"] } },
    {
      "Ihwi": {
        expand: [
          {
            "WorkItem": {
              select: ["ProjectId"]
            }   
          },
          {
            "Inspection": {
              select: ["InspectionNumber"]
            }
          },
          {
            "Inspection": {
              expand:
              {
                "Rassignment": {
                  expand:
                  {
                    "SystemUser": { "select": ["Name"] }
                  }
                }
              }
            }
          }
        ]
      }
    }
  ];
}

export default Material;
